import * as DeliveryNoteStore from './DeliveryNoteStore';
import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Res, Permission, DeliveryNoteDTO } from 'core/api';
import { showCloseDocumentScreen } from 'pos/modules/helpers/document-creation';
import { addPrecondition, Command } from 'pos/common';
import * as NotePreconditions from './Preconditions';
import { DeliveryNoteFacade } from 'pos/facades';
import { Message } from 'core/ui-next/modal';

const createInvoice = addPrecondition(
	Preconditions.ensure(Permission.DeliveryNote_Invoice),
	async function (notes: DeliveryNoteDTO[]) {
		const ticketGlobalId = notes.length === 0 || notes.length > 1 ? null : notes[0].TicketGlobalId;
		const pendingAmount = await DeliveryNoteFacade.getPendingAmount(notes.map(x => x.Id));
		return await showCloseDocumentScreen({
			layout: 'CloseDeliveryNote',
			getDocument: () => {
				const customer = notes[0].Customer;
				return {
					ticketIds: notes.map(x => x.TicketId),
					ticketGlobalId,
					pendingAmount,
					customer
				};
			},
			setCustomer: async _ => { },
			closeDocument: params => DeliveryNoteStore.createInvoice(notes.map(x => x.Id), params)

		});
	});

const createRefund = addPrecondition(
	// OJO: Este permiso es el que se usaba en el PC. No hay permisos específicos
	// para emitir devoluciones desde albaranes o desde pedidos, siempre se usa Ticket_Refund
	Preconditions.ensure(Permission.Ticket_Refund),
	async function (notes: DeliveryNoteDTO[]) {

		const ticketGlobalId = notes.length === 0 || notes.length > 1 ? null : notes[0].TicketGlobalId;
		return await showCloseDocumentScreen({
			layout: 'CreateRefund',
			getDocument: () => {
				const pendingAmount = -1 * notes.sum(x => x.PendingAmount);
				const customer = notes[0].Customer;
				return {
					ticketIds: notes.map(x => x.TicketId),
					ticketGlobalId,
					pendingAmount,
					customer
				};
			},
			setCustomer: async _ => { },
			closeDocument: params => DeliveryNoteStore.createRefund(notes.map(x => x.Id), params)

		});
	});



// OJO: No lleva permiso porque internamente distingue entre invoice o refund para
// aplicar el permiso necesario. No lo saco a dos ficheros porque el código es el mismo
// para invoice y refund (sólo cambia el mode que se pasa a closeTicket) y sacarlo a dos
// fichero hace que sea todo más complicado y se duplique más código. Teniéndolo todo
// junto me parece más sencillo mantener sincronizada la forma en que se usa el closeTicket

declare global {
	interface CommandType {
		createInvoiceOrRefundDeliveryNotes: (notes: DeliveryNoteDTO[]) => Promise<Result>
	}
}

Command.register('createInvoiceOrRefundDeliveryNotes', Preconditions.ensureIsNotLite, async (notes: DeliveryNoteDTO[]): Promise<Result> => {
	const isRefund = notes.sum(d => d.NetAmount) < 0;

	const canBeInvoiced = await NotePreconditions.canBeInvoiced(notes);
	if (!canBeInvoiced)
		return Result.error();

	if (isRefund && !(await Message.confirm(Res.Msg.MSG_EMIT_REFUND())).ok)
		return Result.error();

	return isRefund ? createRefund(notes) : createInvoice(notes);
});
